import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Url from '../../data/url';
import { BOTTOM_NAVI } from '../../data/define';
import IcCameraOff from '../../assets/image/navigation/ic_navi_camera_off.svg';
import IcHomeOn from '../../assets/image/navigation/ic_navi_home_on.svg';
import IcHomeOff from '../../assets/image/navigation/ic_navi_home_off.svg';
import IcHistoryOn from '../../assets/image/navigation/ic_navi_history_on.svg';
import IcHistoryOff from '../../assets/image/navigation/ic_navi_history_off.svg';
import IcEducationOn from '../../assets/image/navigation/ic_navi_edu_on.svg';
import IcEducationOff from '../../assets/image/navigation/ic_navi_edu_off.svg';
import IcMyOn from '../../assets/image/navigation/ic_navi_my_on.svg';
import IcMyOff from '../../assets/image/navigation/ic_navi_my_off.svg';
import IcCommunityOn from '../../assets/image/navigation/ic_navi_cummunity_on.svg';
import IcCommunityOff from '../../assets/image/navigation/ic_navi_cummunity_off.svg';
import { useTranslation } from '../../hook/useTranslation';

interface BottomNavigationProps {
  focusTab?: number;
}

export default function BottomNavigation({ focusTab = 0 }: BottomNavigationProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const homeSx = focusTab === BOTTOM_NAVI.HOME ? { color: '#1C1C1C' } : {};
  const historySx = focusTab === BOTTOM_NAVI.HISTORY ? { color: '#1C1C1C' } : {};
  const educationSx = focusTab === BOTTOM_NAVI.EDUCATION ? { color: '#1C1C1C' } : {};
  const mySx = focusTab === BOTTOM_NAVI.MY ? { color: '#1C1C1C' } : {};
  const communitySx = focusTab === BOTTOM_NAVI.COMMUNITY ? { color: '#1C1C1C' } : {};

  return (
    <>
      {/* 중앙 플로팅 촬영 버튼 */}
      <button
        type="button"
        className="z-100 min-w-[70px] h-[70px] bg-white rounded-full flex items-center justify-center fixed bottom-[10px] left-[50%] translate-x-[-50%] p-[10px]"
        style={{
          boxShadow: '0 -4px 10px rgba(0,0,0,0.1)',
        }}
        onClick={() => navigate(Url.KidsRegisterUpload)}
      >
        <img src={IcCameraOff} alt="camera" />
      </button>

      {/* Navigation */}
      <div className="z-50 w-full min-w-[300px] fixed bottom-0 left-0 right-0 flex items-center justify-evenly bg-white border-t border-[#EAEAEA]">
        <Link
          className="my-[8px] w-[50px] min-w-[50px] flex flex-col items-center justify-end"
          to={Url.Home}
        >
          <img
            src={focusTab === BOTTOM_NAVI.HOME ? IcHomeOn : IcHomeOff}
            alt="home"
            className="w-[24px] h-[24px] shrink-0"
          />
          <div
            className="font-[700] text-[#969696] text-[11px] mt-1"
            style={{
              ...homeSx,
            }}
          >
            {t('nav.home')}
          </div>
        </Link>
        <Link
          className="flex my-[8px] w-[50px] min-w-[50px] flex-col items-center justify-end"
          to={Url.History}
        >
          <img
            src={focusTab === BOTTOM_NAVI.HISTORY ? IcHistoryOn : IcHistoryOff}
            alt="history"
            className="w-[24px] h-[24px] shrink-0"
          />
          <div
            className="font-[700] text-[#969696] text-[11px] mt-1"
            style={{
              ...historySx,
            }}
          >
            {t('nav.growth_record')}
          </div>
        </Link>
        <div className="w-[80px] bg-transparent h-full" />
        <Link
          className="flex my-[8px] w-[50px] min-w-[50px] flex-col items-center justify-end"
          to={Url.Education}
        >
          <img
            src={focusTab === BOTTOM_NAVI.EDUCATION ? IcEducationOn : IcEducationOff}
            alt="education"
            className="w-[24px] h-[24px] shrink-0"
          />
          <div
            className="font-[700] text-[#969696] text-[11px] mt-1"
            style={{
              ...educationSx,
            }}
          >
            {t('nav.education')}
          </div>
        </Link>
        <Link
          className="my-[8px] w-[50px] min-w-[50px] flex flex-col items-center justify-end"
          to={Url.Community}
        >
          <img
            src={focusTab === BOTTOM_NAVI.COMMUNITY ? IcCommunityOn : IcCommunityOff}
            alt="community"
            className="w-[24px] h-[24px] shrink-0"
          />
          <div
            className="font-[700] text-[#969696] text-[11px] mt-1"
            style={{
              ...communitySx,
            }}
          >
            {t('my.community')}
          </div>
        </Link>
        <Link
          className="my-[8px] w-[50px] min-w-[50px] flex flex-col items-center justify-end"
          to={Url.My}
        >
          <img
            src={focusTab === BOTTOM_NAVI.MY ? IcMyOn : IcMyOff}
            alt="my"
            className="w-[24px] h-[24px] shrink-0"
          />
          <div
            className="font-[700] text-[#969696] text-[11px] mt-1"
            style={{
              ...mySx,
            }}
          >
            {t('nav.my')}
          </div>
        </Link>
      </div>
    </>
  );
}
